import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const events = {
  namespaced: true,
  state: {
    datas: [],
    queryParam: {},
    modalCreate: false,
    tambah_kegiatan: {},
    modalUpdate: false,
    is_ujian: false,
    count: "0",
  },
  getters: {
    allEvents(state) {
      return state.datas;
    },
    count(state) {
      return state.count;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      const dataNew = datas?.map((event) => ({
        event_id: event.event_id,
        event_name: event.title,
        name: event.title,
        start: event.start_date.substr(0, 10),
        end: event.end_date.substr(0, 10),
        start_time: event.start_date.substr(11, 5),
        end_time: event.end_date.substr(11, 5),
        description: event.description,
        timed: event.start_date.substr(11, 5),
        // teacher_id: event.teacher_id,
        // mata_pelajaran_id: event.mata_pelajaran_id,
        // is_ujian: event.is_ujian,
        // periode_ujian: event.periode_ujian,
        // semester_ujian: event.semester_ujian,
        // tahun_ajaran_ujian: event.tahun_ajaran_ujian,
        // subject: event.subject,
        // student_id: event.ketua_kelas,
        colors: event.color,
        // teacher_event: event.teacher_event,
      }));
      state.datas = dataNew;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_IS_UJIAN(state, data) {
      state.is_ujian = data;
    },
  },
  actions: {
    async getCount({ commit, state }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/event/count/all")
        .then(({ data }) => {
          state.count = data;
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    ClearAll({ state }) {
      state.tambah_kegiatan = {};
    },
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("backoffice/event")
        .then(({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_DATAS", error.data);
        });
    },
    onRefresh({ state }) {
      store.dispatch("events/all");
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      }
    },
    confirmation({ commit, state }, payload) {
      confirmations.confirmationForm(payload[0], `events/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      // state.tambah_kegiatan.teacher_event = payload;
      // state.tambah_kegiatan.is_ujian = state.is_ujian;
      return await AuthenticationService.post(
        "backoffice/event",
        state.tambah_kegiatan
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("events/onRefresh");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },

    async update({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.put(
        "backoffice/event/" + state.tambah_kegiatan.event_id,
        state.tambah_kegiatan
      )
        .then(({ data }) => {
          // console.log(JSON.stringify(data));
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("events/onRefresh");
          state.modalUpdate = false;
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default events;
